import Card from "components/card";
import DisclosureCard from "components/DisclosureCard";
import GridDetailsLayout from "components/GridDetailsLayout";

const ThirdCardSx = ({ state }) => {
    return (
        <DisclosureCard
            extra={"w-full p-4 sm:overflow-x-auto"}
            button={() => (
                <div className="relative mb-8 flex items-center justify-between">
                    <div className="flex">
                        <div className=" text-2xl font-bold text-gray-800 dark:text-white">
                            Dati anagrafici
                        </div>
                    </div>
                    <div>
                        <img
                            src="/icon/chevron-down.svg"
                            alt="Dati anagrafici"
                            className="text-[26px] font-bold uppercase text-navy-700 dark:text-white"
                        />
                    </div>
                </div>
            )}
            content={() => (
                <GridDetailsLayout
                    dataConfig={[
                        {
                            key: "Ragione sociale",
                            value: state.data.name,
                        },
                        {
                            key: "Tel.",
                            value: state.data.phone1,
                        },
                        {
                            key: "Tel. 2",
                            value: state.data.phone2,
                        },
                        {
                            key: "Email",
                            value: state.data.email,
                        },
                        {
                            key: "Cell",
                            value: state.data.mobile,
                        },
                        {
                            key: "Ref. Commerciale",
                            value: state.data.commercial_reference,
                        },
                        {
                            key: "Ref. Tecnico",
                            value: state.data.technical_reference,
                        },
                        {
                            key: "Indirizzo",
                            value: (
                                <span>
                                    {state.data.address || ""},{" "}
                                    {state.data.zip_code || ""}{" "}
                                    {state.data.city || ""} (
                                    {state.data.province || ""}) -{" "}
                                    {state.data.country || ""},
                                </span>
                            ),
                        },
                        {
                            key: "Descrizione",
                            value: state.data.description,
                        },
                        {
                            key: "Richiesta inserita da",
                            value: (
                                <span>
                                    {state.user?.name || ""} (
                                    {state.user?.email || ""})
                                </span>
                            ),
                        },
                    ]}
                />
            )}
        />
    );
};

export default ThirdCardSx;
